import React from 'react';
import useBreakpoint from 'use-breakpoint';
import BuyButton from './BuyButton';
import Square from './Square';

import './BlockModa.scss';
import { isMobile, MQ } from './Media';

const BlockModa: React.FC = () => {
    const { minWidth } = useBreakpoint(MQ, 'sm');

    return (
        <div className="block-moda">
            <div className='row g-0 d-none d-md-none'>
                <div className='col'>
                    <Square color="purple"></Square>
                </div>
                <div className='col'>
                    <Square color="yellow"></Square>
                </div>
                <div className='col'>
                    <Square color="red"></Square>
                </div>
            </div>
            <div className='row g-0'>
                <div className='col-2 d-none d-md-block'>
                    <Square color="red"></Square>
                    <Square color="blue-light"></Square>
                </div>
                <div className='col bg-white acq-text'>
                    <div className="ar-md-2-1 bg-white">
                        <div className="text-center p-3 p-xl-4 d-md-flex flex-column justify-content-around">
                            <h2>А ещё Фрайди –<br />большая модница!</h2>
                            <p className='lh-1'>Она и дня не может прожить без смены образа!
                            Три сменные причёски разных цветов –
                            уже в наборе! Менять их очень легко:
                            они на магнитах.</p>
                            <h3>Дружи с Фрайди!<br />Дружи с Пятницей!</h3>
                        </div>
                        {isMobile(minWidth) && <div className="text-center button-box pt-2 pb-5">
                            <BuyButton />
                        </div>}
                    </div>
                </div>
                <div className='col-2 d-none d-md-block'>
                    <Square color="green"></Square>
                    <Square color="blue"></Square>
                </div>
            </div>
        </div>
    );
};

export default BlockModa;